import { BaseClass } from './BaseClass';

export class Recommendation extends BaseClass{
  body!: string;
  user!: any;
  postDate!: any;
}
